var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.512 34.645l-15.753-4.69a4.388 4.388 0 0 1 1.211-8.58h9.67a8.8 8.8 0 0 1 4.989 1.559 2.244 2.244 0 0 0 2.844-.3l5.076-5.047a2.433 2.433 0 0 0-.263-3.637A20.4 20.4 0 0 0 25.669 9.5V2.375A2.362 2.362 0 0 0 23.336 0h-4.668a2.362 2.362 0 0 0-2.334 2.375V9.5h-.365A16.154 16.154 0 0 0 .07 27.253c.613 6.847 5.747 12.41 12.224 14.339l14.951 4.453a4.395 4.395 0 0 1 3.092 4.2 4.34 4.34 0 0 1-4.3 4.379h-9.674a8.8 8.8 0 0 1-4.989-1.559 2.244 2.244 0 0 0-2.844.3L3.454 58.41a2.433 2.433 0 0 0 .263 3.637A20.4 20.4 0 0 0 16.334 66.5v7.125A2.362 2.362 0 0 0 18.668 76h4.668a2.362 2.362 0 0 0 2.334-2.375V66.47a16.266 16.266 0 0 0 4.843-31.825z",
    transform: "translate(-0.003)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.c247e46a4daf2fcd0c9c28b90553fce0.svg";
export { ForwardRef as ReactComponent };